import { SkuDTO } from '@/types/api/sku';

export default async function getNewSkus(): Promise<SkuDTO[]> {
  const response = await fetch('/api/get-new-skus');
  if (!response.ok) {
    throw new Error('Failed to fetch new skus');
  }
  const json = await response.json();
  return json;
}
